import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import CollectionsBootstrap from 'modules/contracts/lib/EmployeesCollectionsBootstrap'
import employees from 'modules/employees/store/collections/employees'
import jobLevelsCollection from 'modules/job_catalog/store/collections/levels'
import jobRolesCollection from 'modules/job_catalog/store/collections/roles'
import jobSalaryRangesCollection from 'modules/job_catalog/store/collections/salaryRanges'

const Container = () => {
  const { navigation } = useNavigation()

  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()
  const employee = employees.get(Number(id))
  const { loading, value: authorized } = useAsyncCan('contracts.read', employee)

  const { loading: loadingJobCatalogData } = useAsyncData(
    () =>
      Promise.all([
        jobRolesCollection.fetch(),
        jobLevelsCollection.fetch(),
        jobSalaryRangesCollection.fetch(),
      ]),
    []
  )
  const context = useOutletContext()
  if (loading || loadingJobCatalogData) return <Loading />

  if (authorized) {
    return <Outlet context={context} />
  }

  navigate(navigation.employees.id.fullPath({ id }))

  return null
}

const RootPage = () => (
  <CollectionsBootstrap>
    <Container />
  </CollectionsBootstrap>
)

export default RootPage
